import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { MdOutlineStarPurple500 } from "react-icons/md"
import quto from '../image/New Stud Dash/quote.46562a2f.webp';
import s2pic1 from "../image/krish_lathiya.webp";
import s2pic2 from "../image/prem_stu.webp";
import s2pic3 from "../image/krish_vagadiya.webp";
import s2pic4 from "../image/Rucha.webp";
import s2pic5 from "../image/khushi.webp";
import s2pic6 from "../image/gresa.webp";
import studvideo1 from "../image/video_1.webp";
import studvideo2 from "../image/video_2.webp";
import studvideo3 from "../image/video_3.webp";
import studvideo4 from "../image/video_4.webp";
import studvideo5 from "../image/video_5.webp";
import studvideo6 from "../image/video_6.webp";
import studvideo7 from "../image/video_7.webp";
import studvideo8 from "../image/video_8.webp";
import { useState } from "react";
import { Link } from "react-router-dom";
import GetStarted from "../component/GetStarted";
const video = [
    {
        src: studvideo1,
        videoUrl:
            "https://www.youtube.com/embed/tOjg1DNEUz8?si=V8SSYNDAYAI72bDr&start=41",
    },
    {
        src: studvideo2,
        videoUrl:
            "https://www.youtube.com/embed/e-4iwDlkbOE?si=DcN1smCXLfggOveg&start=2",
    },
    {
        src: studvideo3,
        videoUrl:
            "https://www.youtube.com/embed/pCuX9dq_pc4?si=HsyDWXXDFI9AQB8p",
    },
    {
        src: studvideo4,
        videoUrl:
            "https://www.youtube.com/embed/QFlJhskTMZI?si=gO1WAq-Y8aV63dEz",
    },
    {
        src: studvideo5,
        videoUrl:
            "https://www.youtube.com/embed/KwHpYUQ0HwE?si=1W4iMHaqrYmCuV0V",
    },
    {
        src: studvideo6,
        videoUrl:
            "https://www.youtube.com/embed/wQ8t9CU2b-8?si=24JedpsY0PXtytzG",
    },
    {
        src: studvideo7,
        videoUrl:
            "https://www.youtube.com/embed/RvryU3Hcatg?si=QvfYeEvFkYTe1SZu",
    },
    {
        src: studvideo8,
        videoUrl:
            "https://www.youtube.com/embed/Oh0FJYmByew?si=QRUzHzDmDX39diNK",
    },
    // Add more video data here...
]

const testimonials = [
    {
        name: "Krish Lakhani",
        grade: "12th Commerce",
        image: s2pic1,
        review:
            "CareerSahi દ્વારા મને ખબર પડી કે Goal કઈ રીતે સેટ થાય અને એના પર કઈ રીતે વર્ક કરી શકાય.",
    },
    {
        name: "Prem Solanki",
        grade: "12th Science",
        image: s2pic2,
        review:
            "મને ખબર જ નહોતી કે આટલી બધી સ્કોલરશીપ અવેઇલેબલ છે. CareerSahi એ મને મારા એજ્યુકેશન અને કરિયર ડેવલપમેન્ટ માટે બેસ્ટ ઓપ્શન શોધવામાં મદદ કરી.",
    },
    {
        name: "Vagadiya Krish",
        grade: "12th Commerce",
        image: s2pic3,
        review:
            "મારી સ્કિલ્સ અને આવડતોને સમજીને CareerSahi એ મને ફિલ્ડ સિલેક્ટ કરવામાં મદદ કરી, હવે હું મારા ફ્યુચરને લઈને ખુબ જ કોન્ફિડન્ટ છું અને મારી પાસે પરફેક્ટ કરિયર રોડમેપ છે.",
    },
    {
        name: "Rucha Chauhan",
        grade: "10th Standard",
        image: s2pic4,
        review:
            "CareerSahi એ મને બીજાને ફોલો કરીને ડિસિઝન લેવાના બદલે આપણામાં રહેલી તાકાતને ઓળખીને ફિલ્ડ ચોઈસ કરવા વિષે સમજાવ્યું. હવે હું જાણું છું કે બેસ્ટ કરિયર માટે બેસ્ટ પ્લાન કઈ રીતે બનાવવો અને એની ઉપર કઈ રીતે વર્ક કરવું.",
    },
    {
        name: "Khushi Vardoriya",
        grade: "10th Standard",
        image: s2pic5,
        review: "Career Counselling માટે CareerSahi એ મારા માટે Best Decision હતું.",
    },
    {
        name: "Gresa Golakiya",
        grade: "12th Commerce",
        image: s2pic6,
        review:
            "ગાઈડન્સ મેળવ્યા પહેલા મારુ પણ એવું જ હતું કે મારી ફ્રેન્ડ્સ જે ફિલ્ડમાં જશે એ જ ફિલ્ડ માં હું જઈશ, પરંતુ હવે મેં CareerSahi દ્વારા પ્રોપર રિસર્ચ કરતા શીખીને વિવિધ ફિલ્ડ્સનુ રિસર્ચ કરી અને મેં મારી ફિલ્ડ સિલેક્ટ કરી છે અને હું એમાં ખુબ જ સારું પરફોર્મન્સ આપી રહી છું.",
    },
];
function Testimonials() {
    const [activeTab, setActiveTab] = useState("student");
    // video
    const [videoboxOpen, setVideoboxOpen] = useState(false);
    const [currentVideo, setCurrentVideo] = useState(0);
    const openVideo = (videoUrl) => {
        const autoplayUrl = videoUrl.split("?")[0] + "?autoplay=1";
        setCurrentVideo(autoplayUrl);
        setVideoboxOpen(true);
    };
    return (
        <>
            {/* hero sections */}
            <Container fluid style={{ background: '#1E2538' }} className="hero_all overflow-hidden">
                <Row className="justify-content-center">
                    <Col xl="12">
                        <div class="header_banner align-self-center  text-center pt-0">
                            <br />
                            <div className="main_part positions-relative">
                                <div className="fs-3  head_text text-white">CareerSahi</div>
                                <h1 class="fw-bold h1_title">Student's Testimonials</h1>
                            </div>
                            <br />
                        </div>
                    </Col>
                </Row>
            </Container>
            {/* ----------------------------Students review swiper---------------------------- */}
            <Container fluid className="testimonial">
                <Row className="justify-content-center pt-5">
                    <Col xl="10" xxl="9" className="pt-4">
                        <Row className="justify-content-center">
                            <Col xs="auto">
                                <div className="mb-5 text-center main_tab">
                                    <button
                                        className={`mx-2 border-0 ${activeTab === "student" ? "testimimonals-custom-button-active" : "testimimonals-custom-button"}`}
                                        onClick={() => setActiveTab("student")}
                                    >
                                        Student
                                    </button>
                                    <button
                                        className={`mx-2 border-0 ${activeTab === "video" ? "testimimonals-custom-button-active" : "testimimonals-custom-button"}`}
                                        onClick={() => setActiveTab("video")}
                                    >
                                        Video
                                    </button>
                                </div>
                            </Col>
                        </Row>
                        {activeTab === "student" && (
                            <>
                                <Row className="g-4">
                                    {testimonials.map((testimonial, index) => (
                                        <Col key={index} sm="6" lg="4">
                                            <Card className="border-0 bg-white shadow h-100">
                                                <div className="p-4 justify-content-between d-flex flex-column h-100">
                                                    <div>
                                                        <img height={40} src={quto} alt="quote_image" />
                                                        <div className="border rounded-2 position-relative mt-2 text-center p-3">
                                                            <div>
                                                                <img
                                                                    src={testimonial.image}
                                                                    alt="student_image"
                                                                    className="student_image"
                                                                />
                                                            </div>
                                                            <div className="pt-5 desc_header mt-2">
                                                            {testimonial.review}
                                                                {index === 0 && (
                                                                    <>
                                                                        <br />
                                                                        Thank You, CareerSahi
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="text-center">
                                                        <h6 className="mt-3">
                                                            {testimonial.name}: <span className="text-muted">{testimonial.grade}</span>
                                                        </h6>
                                                        <div className="stars mt-2">
                                                            {[...Array(5)].map((_, i) => (
                                                                <MdOutlineStarPurple500 color="#FBBC05" key={i} className="fs-4" />
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            </>
                        )}
                        {activeTab === "video" && (
                            <>
                                <Row className="g-4 ">
                                    {video?.map((item, index) => (
                                        <Col sm="6" lg="4" key={index}>
                                            <img className="col-12 rounded-3"
                                                src={item.src}
                                                alt="Click to play video"
                                                style={{ cursor: "pointer", objectFit: "contain" }}
                                                onClick={() => openVideo(item.videoUrl)}
                                            />
                                        </Col>
                                    ))}
                                </Row>
                            </>
                        )}
                        {/* pop up */}
                        {videoboxOpen && (
                            <>
                                <div className="lightboxx">
                                    <div className="video-container">
                                        <span className="close-lightboxer" onClick={() => setVideoboxOpen(false)}>×</span>
                                        <iframe key={currentVideo}
                                            src={currentVideo}
                                            title="YouTube video player"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            referrerPolicy="strict-origin-when-cross-origin"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                </div>
                            </>
                        )}
                    </Col>
                </Row>
            </Container>
            {/* contact */}
            <GetStarted />
        </>
    )
}
export default Testimonials